import { useState, useEffect, useCallback } from "react";
import api from "../api";

const ORANGE = "#EE6A1A";

const STATUS = {
  agendado:   { label: "Agendado",   cor: "#579bfc" },
  confirmado: { label: "Confirmado", cor: "#00c875" },
  atendido:   { label: "Atendido",   cor: "#1D9E75" },
  faltou:     { label: "Faltou",     cor: "#e2445c" },
  desmarcado: { label: "Desmarcado", cor: "#98A2B3" },
};

const HORA_INICIO = 7;
const HORA_FIM = 24;
const PASSO = 30;

const dois = (n) => String(n).padStart(2, "0");
const iso = (d) => d.getFullYear() + "-" + dois(d.getMonth() + 1) + "-" + dois(d.getDate());
const hhmm = (d) => dois(new Date(d).getHours()) + ":" + dois(new Date(d).getMinutes());
const somaDias = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const inicioSemana = (d) => { const x = new Date(d); x.setDate(x.getDate() - x.getDay()); x.setHours(0, 0, 0, 0); return x; };
const DIAS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];
const porExtenso = (d) => DIAS[d.getDay()] + ", " + dois(d.getDate()) + "/" + dois(d.getMonth() + 1);

const slots = () => {
  const out = [];
  for (let h = HORA_INICIO; h < HORA_FIM; h++) for (let m = 0; m < 60; m += PASSO) out.push(dois(h) + ":" + dois(m));
  return out;
};

// A grade nunca pode esconder ninguem. Se existe atendimento antes das 7h ou
// depois das 24h, a faixa cresce para caber - ela so aumenta, nunca encolhe,
// para o dia normal continuar com a mesma cara de sempre.
const slotsPara = (agendamentos) => {
  const horas = (agendamentos || [])
    .map((a) => (a && a.inicio ? new Date(a.inicio).getHours() : null))
    .filter((h) => h !== null && !isNaN(h));
  if (!horas.length) return slots();

  let ini = Math.min.apply(null, horas) - 1;
  let fim = Math.max.apply(null, horas) + 2;
  if (ini > HORA_INICIO) ini = HORA_INICIO;
  if (fim < HORA_FIM) fim = HORA_FIM;
  if (ini < 0) ini = 0;
  if (fim > 24) fim = 24;

  const out = [];
  for (let h = ini; h < fim; h++) for (let m = 0; m < 60; m += PASSO) out.push(dois(h) + ":" + dois(m));
  return out;
};

const MSG_PADRAO = "Olá {paciente}! Confirmando seu horário na {clinica} no dia {data} às {hora}{procedimento}.\n\nConfirme ou avise que não vai conseguir vir por aqui: {link}";

const soDigitos = (t) => String(t || "").replace(/\D/g, "");
const paraWhats = (tel) => {
  const n = soDigitos(tel);
  if (!n) return "";
  if (n.length <= 11) return "55" + n;
  return n;
};
const nomeEmpresa = () => {
  try {
    const c = JSON.parse(localStorage.getItem("crm_config") || "{}");
    if (c && c.nome) return c.nome;
    const e = JSON.parse(localStorage.getItem("crm_empresa") || "{}");
    return (e && e.nome) || "nossa clínica";
  } catch (x) { return "nossa clínica"; }
};
const linkPublico = (a) => (a && a.tokenPublico) ? (window.location.origin + "/api/p/" + a.tokenPublico) : "";
const montarMensagem = (modelo, a) => {
  const d = new Date(a.inicio);
  const link = linkPublico(a);
  let texto = String(modelo || MSG_PADRAO);
  if (link && texto.indexOf("{link}") === -1) texto += "\n\nConfirme ou avise que não vai conseguir vir por aqui: {link}";
  return texto
    .replace(/{paciente}/g, String(a.pacienteNome || "").split(" ")[0])
    .replace(/{data}/g, dois(d.getDate()) + "/" + dois(d.getMonth() + 1))
    .replace(/{hora}/g, hhmm(d))
    .replace(/{procedimento}/g, a.procedimento ? " (" + a.procedimento + ")" : "")
    .replace(/{clinica}/g, nomeEmpresa())
    .replace(/{link}/g, link);
};

function ModalConfirmacao({ onFechar, onMudou }) {
  const [dias, setDias] = useState(1);
  const [lista, setLista] = useState([]);
  const [modelo, setModelo] = useState(MSG_PADRAO);
  const [editandoMsg, setEditandoMsg] = useState(false);
  const [carregando, setCarregando] = useState(true);
  const [enviados, setEnviados] = useState({});
  const [waAtivo, setWaAtivo] = useState(false);
  const [enviandoTodas, setEnviandoTodas] = useState(false);

  useEffect(() => {
    api.get("/empresa").then(({ data }) => { if (data && data.mensagemConfirmacao) setModelo(data.mensagemConfirmacao); }).catch(() => {});
  }, []);

  useEffect(() => {
    api.get("/whatsapp/status").then(({ data }) => setWaAtivo(!!(data && data.ativo))).catch(() => {});
  }, []);

  useEffect(() => {
    let vivo = true;
    setCarregando(true);
    api.get("/agenda/para-confirmar", { params: { dias } })
      .then(({ data }) => { if (vivo) { setLista(data.agendamentos || []); setCarregando(false); } })
      .catch(() => { if (vivo) { setLista([]); setCarregando(false); } });
    return () => { vivo = false; };
  }, [dias]);

  const salvarModelo = async () => {
    try { await api.put("/empresa", { mensagemConfirmacao: modelo }); setEditandoMsg(false); }
    catch (e) { window.alert("Não foi possível salvar a mensagem."); }
  };

  const enviarTodas = async () => {
    const ids = lista.filter((a) => a.telefone).map((a) => a._id);
    if (!ids.length) return window.alert("Nenhum paciente com telefone nesse dia.");
    if (!window.confirm("Enviar a confirmação para " + ids.length + " paciente(s) agora, pelo WhatsApp da clínica?")) return;
    setEnviandoTodas(true);
    try {
      const { data } = await api.post("/whatsapp/confirmar", { ids });
      const falhas = (data.resultados || []).filter((r) => !r.enviado);
      window.alert("Enviadas: " + data.enviados + (falhas.length ? "\nNão saíram: " + falhas.map((f) => f.paciente + " (" + f.motivo + ")").join(", ") : ""));
      setEnviados((e) => { const n = { ...e }; ids.forEach((i) => { n[i] = true; }); return n; });
    } catch (err) {
      window.alert((err.response && err.response.data && err.response.data.message) || "Não foi possível enviar.");
    } finally { setEnviandoTodas(false); }
  };

  const abrirWhats = (a) => {
    const fone = paraWhats(a.telefone);
    if (!fone) return window.alert("Esse paciente está sem telefone. Edite o agendamento e inclua o número.");
    window.open("https://wa.me/" + fone + "?text=" + encodeURIComponent(montarMensagem(modelo, a)), "_blank", "noopener");
    setEnviados((e) => ({ ...e, [a._id]: true }));
  };

  const marcar = async (a, status) => {
    try {
      const { data } = await api.patch(`/agenda/${a._id}/status`, { status });
      setLista((l) => l.filter((x) => x._id !== a._id));
      onMudou(data.agendamento);
    } catch (err) { window.alert("Não foi possível marcar."); }
  };

  const inp = { width: "100%", boxSizing: "border-box", padding: "9px 11px", borderRadius: 8, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "'Inter',sans-serif", outline: "none" };
  const botao = (cor, cheio) => ({ padding: "6px 11px", borderRadius: 7, border: `1px solid ${cor}66`, background: cheio ? cor : "transparent", color: cheio ? "#fff" : cor, fontSize: 12, fontWeight: 700, cursor: "pointer", fontFamily: "inherit", whiteSpace: "nowrap" });

  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 640, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)" }}>Confirmação de horários</div>
        <p style={{ fontSize: 13, color: "var(--text-muted)", margin: "4px 0 16px" }}>Abre o WhatsApp com a mensagem pronta. Depois da resposta do paciente, marque aqui.</p>

        <div style={{ display: "flex", gap: 8, marginBottom: 14, flexWrap: "wrap", alignItems: "center" }}>
          {[[0, "Hoje"], [1, "Amanhã"], [2, "Depois de amanhã"]].map(([n, r]) => (
            <button key={n} onClick={() => setDias(n)} style={{ padding: "7px 13px", borderRadius: 8, border: `1px solid ${dias === n ? ORANGE : "var(--border-color)"}`, background: dias === n ? ORANGE : "transparent", color: dias === n ? "#fff" : "var(--text-secondary)", fontSize: 13, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>{r}</button>
          ))}
          <div style={{ flex: 1 }} />
          <button onClick={() => setEditandoMsg((v) => !v)} style={{ background: "none", border: 0, color: ORANGE, fontSize: 12.5, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>{editandoMsg ? "Fechar mensagem" : "Editar mensagem"}</button>
        </div>

        {waAtivo && (
          <div style={{ marginBottom: 14 }}>
            <button onClick={enviarTodas} disabled={enviandoTodas || !lista.length}
              style={{ width: "100%", padding: 12, borderRadius: 9, border: 0, background: "#25D366", color: "#fff", fontWeight: 700, fontSize: 13.5, cursor: "pointer", fontFamily: "inherit", opacity: (enviandoTodas || !lista.length) ? .5 : 1 }}>
              {enviandoTodas ? "Enviando…" : "Enviar todas agora pelo WhatsApp da clínica"}
            </button>
            <div style={{ fontSize: 11.5, color: "var(--text-muted)", marginTop: 6, textAlign: "center" }}>
              A paciente responde tocando num botão dentro do WhatsApp — a resposta cai aqui sozinha.
            </div>
          </div>
        )}

        {editandoMsg && (
          <div style={{ marginBottom: 16, padding: 14, borderRadius: 10, background: "var(--hover-bg)" }}>
            <textarea rows={3} value={modelo} onChange={(e) => setModelo(e.target.value)} style={{ ...inp, resize: "vertical" }} />
            <div style={{ fontSize: 11, color: "var(--text-muted)", margin: "8px 0" }}>Você pode usar: {"{paciente}"} {"{data}"} {"{hora}"} {"{procedimento}"} {"{clinica}"} {"{link}"}</div>
            <button onClick={salvarModelo} style={botao(ORANGE, true)}>Salvar mensagem</button>
          </div>
        )}

        {carregando && <div style={{ fontSize: 13, color: "var(--text-muted)", padding: "16px 0" }}>Carregando…</div>}
        {!carregando && !lista.length && <div style={{ fontSize: 13, color: "var(--text-muted)", padding: "20px 0", textAlign: "center" }}>Nenhum horário aguardando confirmação nesse dia.</div>}

        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {lista.map((a) => (
            <div key={a._id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "10px 12px", borderRadius: 10, background: "var(--hover-bg)", flexWrap: "wrap" }}>
              <div style={{ fontSize: 13, fontWeight: 800, color: "var(--text-primary)", minWidth: 46 }}>{hhmm(a.inicio)}</div>
              <div style={{ flex: "1 1 160px", minWidth: 0 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-primary)" }}>{a.pacienteNome}</div>
                <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>{a.procedimento || "—"}{a.telefone ? " · " + a.telefone : " · sem telefone"}</div>
              </div>
              <button onClick={() => abrirWhats(a)} style={botao("#25D366", !enviados[a._id])}>{enviados[a._id] ? "Abrir de novo" : "WhatsApp"}</button>
              <button onClick={() => marcar(a, "confirmado")} style={botao(STATUS.confirmado.cor, false)}>Confirmou</button>
              <button onClick={() => marcar(a, "desmarcado")} style={botao(STATUS.desmarcado.cor, false)}>Desmarcou</button>
            </div>
          ))}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 18 }}>
          <button onClick={onFechar} style={{ padding: "10px 18px", borderRadius: 9, border: "1px solid var(--border-color)", background: "transparent", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

function ModalAgendamento({ ag, profissionais, pacotes, onFechar, onSalvo, onExcluido }) {
  const isNew = !ag._id;
  const [f, setF] = useState({
    pacienteNome: ag.pacienteNome || "",
    telefone: ag.telefone || "",
    procedimento: ag.procedimento || "",
    profissionalId: ag.profissionalId || "",
    profissionalNome: ag.profissionalNome || "",
    sala: ag.sala || "",
    data: ag.inicio ? iso(new Date(ag.inicio)) : iso(new Date()),
    hora: ag.inicio ? hhmm(ag.inicio) : "09:00",
    duracaoMin: ag.duracaoMin || 60,
    valor: ag.valor || "",
    pacoteId: ag.pacoteId || "",
    obs: ag.obs || "",
  });
  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);
  const [catalogo, setCatalogo] = useState([]);
  useEffect(() => { api.get("/catalogo").then(({ data }) => setCatalogo(Array.isArray(data) ? data : [])).catch(() => {}); }, []);
  const set = (k, v) => setF((x) => ({ ...x, [k]: v }));
  const escolherProcedimento = (v) => setF((x) => {
    const it = catalogo.find((c) => c.nome === v);
    return { ...x, procedimento: v,
      duracaoMin: it && it.duracaoMin ? it.duracaoMin : x.duracaoMin,
      valor: it && it.preco ? it.preco : x.valor };
  });

  const inp = { width: "100%", boxSizing: "border-box", padding: "9px 11px", borderRadius: 8, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "'Inter',sans-serif", outline: "none" };
  const lbl = { fontSize: 11, fontWeight: 600, color: "var(--text-secondary)", marginBottom: 5, display: "block", textTransform: "uppercase", letterSpacing: ".04em" };

  const salvar = async () => {
    if (!f.pacienteNome.trim()) return setErro("Informe o paciente.");
    setErro(""); setSalvando(true);
    try {
      const corpo = {
        pacienteNome: f.pacienteNome, telefone: f.telefone, procedimento: f.procedimento,
        profissionalId: f.profissionalId || undefined, profissionalNome: f.profissionalNome,
        sala: f.sala, inicio: new Date(f.data + "T" + f.hora + ":00").toISOString(),
        duracaoMin: Number(f.duracaoMin) || 60, valor: Number(String(f.valor).replace(",", ".")) || 0, pacoteId: f.pacoteId || undefined, obs: f.obs,
      };
      const { data } = isNew ? await api.post("/agenda", corpo) : await api.put(`/agenda/${ag._id}`, corpo);
      onSalvo(data);
    } catch (err) {
      setErro((err.response && err.response.data && err.response.data.message) || "Não foi possível salvar.");
    } finally { setSalvando(false); }
  };

  const mudarStatus = async (novo) => {
    try {
      const { data } = await api.patch(`/agenda/${ag._id}/status`, { status: novo });
      if (data.avisoPacote) window.alert(data.avisoPacote);
      onSalvo(data.agendamento);
    } catch (err) { window.alert((err.response && err.response.data && err.response.data.message) || "Não foi possível mudar o status."); }
  };

  const excluir = async () => {
    if (!window.confirm("Excluir este agendamento?")) return;
    try { await api.delete(`/agenda/${ag._id}`); onExcluido(ag._id); }
    catch (e) { window.alert("Não foi possível excluir."); }
  };

  const btnStatus = (id) => ({
    flex: 1, padding: "8px 6px", borderRadius: 8, fontSize: 12, fontWeight: 700, cursor: "pointer",
    border: `1px solid ${STATUS[id].cor}66`, background: ag.status === id ? STATUS[id].cor : "transparent",
    color: ag.status === id ? "#fff" : STATUS[id].cor, fontFamily: "inherit",
  });

  return (
    <div onClick={onFechar} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.45)", zIndex: 1000, display: "flex", alignItems: "flex-start", justifyContent: "center", padding: "40px 16px", overflowY: "auto" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "var(--card-bg)", borderRadius: 14, padding: 24, width: "100%", maxWidth: 540, boxShadow: "0 20px 60px rgba(0,0,0,.25)" }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: "var(--text-primary)", marginBottom: 18 }}>{isNew ? "Novo agendamento" : "Agendamento"}</div>

        {!isNew && (
          <div style={{ display: "flex", gap: 6, marginBottom: 18 }}>
            {["confirmado", "atendido", "faltou", "desmarcado"].map((s) => (
              <button key={s} onClick={() => mudarStatus(s)} style={btnStatus(s)}>{STATUS[s].label}</button>
            ))}
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 160px", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Paciente</label><input autoFocus value={f.pacienteNome} onChange={(e) => set("pacienteNome", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Telefone</label><input value={f.telefone} onChange={(e) => set("telefone", e.target.value)} placeholder="(00) 00000-0000" style={inp} /></div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 130px", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Procedimento</label><input list="lista-procedimentos" value={f.procedimento} onChange={(e) => escolherProcedimento(e.target.value)} placeholder="Ex: Limpeza de pele" style={inp} /><datalist id="lista-procedimentos">{catalogo.map((c) => <option key={c._id} value={c.nome} />)}</datalist></div>
          <div><label style={lbl}>Sala</label><input value={f.sala} onChange={(e) => set("sala", e.target.value)} placeholder="Opcional" style={inp} /></div>
          <div><label style={lbl}>Valor (R$)</label><input value={f.valor} onChange={(e) => set("valor", e.target.value)} placeholder="0,00" style={inp} /></div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 110px", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Data</label><input type="date" value={f.data} onChange={(e) => set("data", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Hora</label><input type="time" step="300" value={f.hora} onChange={(e) => set("hora", e.target.value)} style={inp} /></div>
          <div><label style={lbl}>Duração</label>
            <select value={f.duracaoMin} onChange={(e) => set("duracaoMin", e.target.value)} style={{ ...inp, appearance: "auto" }}>
              {[15, 30, 45, 60, 90, 120, 180].concat([Number(f.duracaoMin) || 60]).filter((v, i, a) => v > 0 && a.indexOf(v) === i).sort((a, b) => a - b).map((m) => <option key={m} value={m}>{m} min</option>)}
            </select>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
          <div><label style={lbl}>Profissional</label>
            <select value={f.profissionalId} onChange={(e) => { const p = profissionais.find((x) => x._id === e.target.value); set("profissionalId", e.target.value); set("profissionalNome", p ? p.nome : ""); }} style={{ ...inp, appearance: "auto" }}>
              <option value="">Sem profissional</option>
              {profissionais.map((p) => <option key={p._id} value={p._id}>{p.nome}</option>)}
            </select>
          </div>
          <div><label style={lbl}>Pacote (opcional)</label>
            <select value={f.pacoteId} onChange={(e) => set("pacoteId", e.target.value)} style={{ ...inp, appearance: "auto" }}>
              <option value="">Sem pacote</option>
              {pacotes.map((p) => <option key={p._id} value={p._id}>{p.pacienteNome} · {p.procedimento} (restam {p.restam})</option>)}
            </select>
          </div>
        </div>

        {f.pacoteId && <div style={{ fontSize: 12, color: "var(--text-secondary)", marginBottom: 14, padding: "8px 11px", background: "var(--hover-bg)", borderRadius: 8 }}>Ao marcar como atendido, uma sessão é baixada nesse pacote automaticamente.</div>}

        <div style={{ marginBottom: 16 }}>
          <label style={lbl}>Observações</label>
          <textarea rows={2} value={f.obs} onChange={(e) => set("obs", e.target.value)} style={{ ...inp, resize: "vertical" }} />
        </div>

        {erro && <div style={{ fontSize: 13, color: "#ef4444", marginBottom: 12 }}>{erro}</div>}

        <div style={{ display: "flex", gap: 10, justifyContent: "space-between", alignItems: "center" }}>
          {!isNew ? <button onClick={excluir} style={{ padding: "10px 14px", borderRadius: 9, border: "1px solid #ef444455", background: "transparent", color: "#ef4444", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Excluir</button> : <span />}
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={onFechar} style={{ padding: "10px 18px", borderRadius: 9, border: "1px solid var(--border-color)", background: "transparent", color: "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer" }}>Fechar</button>
            <button onClick={salvar} disabled={salvando} style={{ padding: "10px 20px", borderRadius: 9, border: 0, background: ORANGE, color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer", opacity: salvando ? .6 : 1 }}>{salvando ? "Salvando..." : "Salvar"}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function Agenda({ currentUser }) {
  const [dia, setDia] = useState(() => { const d = new Date(); d.setHours(0, 0, 0, 0); return d; });
  const [visao, setVisao] = useState("dia");
  const [lista, setLista] = useState([]);
  const [profissionais, setProfissionais] = useState([]);
  const [pacotes, setPacotes] = useState([]);
  const [filtroProf, setFiltroProf] = useState("");
  const [verDesmarcados, setVerDesmarcados] = useState(false);
  const [modal, setModal] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [confirmacao, setConfirmacao] = useState(false);

  const de = visao === "dia" ? dia : inicioSemana(dia);
  const ate = visao === "dia" ? somaDias(dia, 1) : somaDias(inicioSemana(dia), 7);

  const carregar = useCallback(async () => {
    setCarregando(true);
    try {
      const { data } = await api.get("/agenda", { params: { de: de.toISOString(), ate: ate.toISOString(), profissionalId: filtroProf || undefined, verDesmarcados: verDesmarcados ? 1 : undefined } });
      setLista(data.agendamentos || []);
    } catch (e) { setLista([]); }
    setCarregando(false);
  }, [de.getTime(), ate.getTime(), filtroProf, verDesmarcados]);

  useEffect(() => { carregar(); }, [carregar]);

  useEffect(() => {
    api.get("/users").then(({ data }) => setProfissionais(Array.isArray(data) ? data : (data.users || data.usuarios || []))).catch(() => {});
    api.get("/pacotes").then(({ data }) => setPacotes(data.pacotes || [])).catch(() => {});
  }, []);

  const aposSalvar = (a) => { setModal(null); carregar(); };
  const aposExcluir = (id) => { setModal(null); setLista((l) => l.filter((x) => x._id !== id)); };

  const novoEm = (data, hora) => setModal({ inicio: new Date(iso(data) + "T" + hora + ":00").toISOString(), duracaoMin: 60, profissionalId: filtroProf || "", profissionalNome: (profissionais.find((p) => p._id === filtroProf) || {}).nome || "" });

  const noSlot = (data, hora) => {
    const h = Number(hora.slice(0, 2));
    const m = Number(hora.slice(3));
    return lista.filter((a) => {
      const d = new Date(a.inicio);
      if (iso(d) !== iso(data) || d.getHours() !== h) return false;
      return (d.getMinutes() < PASSO ? 0 : PASSO) === m;
    });
  };

  const cartao = (a) => {
    const st = STATUS[a.status] || STATUS.agendado;
    return (
      <div key={a._id} onClick={(e) => { e.stopPropagation(); setModal(a); }}
        style={{ background: st.cor + "16", borderLeft: `3px solid ${st.cor}`, borderRadius: 6, padding: "5px 8px", marginBottom: 4, cursor: "pointer" }}>
        <div style={{ fontSize: 11.5, fontWeight: 700, color: "var(--text-primary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{hhmm(a.inicio)} {a.pacienteNome}</div>
        {a.procedimento && <div style={{ fontSize: 10.5, color: "var(--text-secondary)", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{a.procedimento}</div>}
        {a.profissionalNome && !filtroProf && visao === "semana" && <div style={{ fontSize: 10, color: "var(--text-muted)" }}>{a.profissionalNome}</div>}
      </div>
    );
  };

  const colunas = visao === "dia"
    ? (filtroProf ? [profissionais.find((p) => p._id === filtroProf)].filter(Boolean) : [{ _id: "", nome: "Todos" }])
    : Array.from({ length: 7 }, (_, i) => somaDias(inicioSemana(dia), i));

  const cabecalho = { fontSize: 12, fontWeight: 700, color: "var(--text-primary)", padding: "10px 8px", textAlign: "center", borderBottom: "2px solid var(--border-color)", position: "sticky", top: 0, background: "var(--card-bg)", zIndex: 1 };
  const celula = { borderTop: "1px solid var(--border-light)", borderLeft: "1px solid var(--border-light)", padding: 4, verticalAlign: "top", cursor: "pointer", minWidth: 150 };
  const btn = (ativo) => ({ padding: "7px 14px", borderRadius: 8, border: `1px solid ${ativo ? ORANGE : "var(--border-color)"}`, background: ativo ? ORANGE : "transparent", color: ativo ? "#fff" : "var(--text-secondary)", fontWeight: 600, fontSize: 13, cursor: "pointer", fontFamily: "inherit" });

  const totais = lista.reduce((a, x) => { a[x.status] = (a[x.status] || 0) + 1; return a; }, {});

  return (
    <div style={{ padding: 24, fontFamily: "'Inter',-apple-system,sans-serif", background: "var(--page-bg)", minHeight: "100vh" }}>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", gap: 16, flexWrap: "wrap", marginBottom: 18 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 800, color: "var(--text-primary)" }}>Agenda</h1>
          <p style={{ margin: "4px 0 0", fontSize: 13, color: "var(--text-muted)" }}>Clique num horário vazio para marcar, ou num agendamento para confirmar e dar baixa.</p>
        </div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        <button onClick={() => setConfirmacao(true)} style={{ padding: "10px 18px", borderRadius: 9, border: `1px solid ${ORANGE}`, background: "transparent", color: ORANGE, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>Confirmação</button>
        <button onClick={() => novoEm(dia, "09:00")} style={{ padding: "10px 18px", borderRadius: 9, border: 0, background: ORANGE, color: "#fff", fontWeight: 700, fontSize: 13, cursor: "pointer" }}>+ Novo agendamento</button>
        </div>
      </div>

      <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", marginBottom: 14 }}>
        <div style={{ display: "flex", gap: 6 }}>
          <button onClick={() => setDia((d) => somaDias(d, visao === "dia" ? -1 : -7))} style={btn(false)}>‹</button>
          <button onClick={() => { const d = new Date(); d.setHours(0, 0, 0, 0); setDia(d); }} style={btn(false)}>Hoje</button>
          <button onClick={() => setDia((d) => somaDias(d, visao === "dia" ? 1 : 7))} style={btn(false)}>›</button>
        </div>
        <div style={{ fontSize: 15, fontWeight: 700, color: "var(--text-primary)", minWidth: 190 }}>
          {visao === "dia" ? porExtenso(dia) : porExtenso(inicioSemana(dia)) + " a " + porExtenso(somaDias(inicioSemana(dia), 6))}
        </div>
        <div style={{ display: "flex", gap: 6 }}>
          <button onClick={() => setVisao("dia")} style={btn(visao === "dia")}>Dia</button>
          <button onClick={() => setVisao("semana")} style={btn(visao === "semana")}>Semana</button>
        </div>
        <select value={filtroProf} onChange={(e) => setFiltroProf(e.target.value)} style={{ padding: "8px 11px", borderRadius: 8, border: "1px solid var(--border-color)", background: "var(--input-bg)", color: "var(--text-primary)", fontSize: 13, fontFamily: "inherit" }}>
          <option value="">Todos os profissionais</option>
          {profissionais.map((p) => <option key={p._id} value={p._id}>{p.nome}</option>)}
        </select>
        <label style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13, color: "var(--text-secondary)", cursor: "pointer" }}>
          <input type="checkbox" checked={verDesmarcados} onChange={(e) => setVerDesmarcados(e.target.checked)} /> Ver desmarcados
        </label>
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 14 }}>
        {Object.keys(STATUS).map((s) => (
          <div key={s} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: "var(--text-secondary)" }}>
            <span style={{ width: 9, height: 9, borderRadius: 3, background: STATUS[s].cor }} />
            {STATUS[s].label} <b style={{ color: "var(--text-primary)" }}>{totais[s] || 0}</b>
          </div>
        ))}
      </div>

      <div style={{ background: "var(--card-bg)", border: "1px solid var(--border-color)", borderRadius: 12, overflow: "auto", maxHeight: "70vh" }}>
        <table style={{ borderCollapse: "collapse", width: "100%", minWidth: visao === "semana" ? 1000 : 420 }}>
          <thead>
            <tr>
              <th style={{ ...cabecalho, width: 62, textAlign: "right", paddingRight: 10 }}>Hora</th>
              {colunas.map((c, i) => (
                <th key={i} style={cabecalho}>{visao === "dia" ? (c.nome || "Todos") : porExtenso(c)}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {slotsPara(lista).map((hora) => (
              <tr key={hora}>
                <td style={{ fontSize: 11, color: "var(--text-muted)", textAlign: "right", paddingRight: 10, borderTop: "1px solid var(--border-light)", whiteSpace: "nowrap", verticalAlign: "top", paddingTop: 6 }}>{hora.endsWith("00") ? hora : ""}</td>
                {colunas.map((c, i) => {
                  const data = visao === "dia" ? dia : c;
                  const itens = noSlot(data, hora).filter((a) => visao === "semana" || !filtroProf || String(a.profissionalId) === String(filtroProf));
                  return (
                    <td key={i} style={celula} onClick={() => novoEm(data, hora)}>
                      {itens.map(cartao)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {carregando && <div style={{ fontSize: 13, color: "var(--text-muted)", marginTop: 10 }}>Carregando…</div>}

      {confirmacao && <ModalConfirmacao onFechar={() => setConfirmacao(false)} onMudou={() => carregar()} />}
      {modal && <ModalAgendamento ag={modal} profissionais={profissionais} pacotes={pacotes} onFechar={() => setModal(null)} onSalvo={aposSalvar} onExcluido={aposExcluir} />}
      {currentUser ? null : null}
    </div>
  );
}
